import { MessageBoxFunctionalLayoutTheme } from '.';
import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface MessageBoxFunctionalLayoutDriver extends BaseDriver {
  getConfirmationButtonText: () => string;
  isConfirmationButtonPrefixIconExists: () => boolean;
  isConfirmationButtonSuffixIconExists: () => boolean;
  clickOnConfirmationButton: () => void;
  getConfirmationButton: () => HTMLElement | null;
  getCancellationButton: () => HTMLElement | null;
  getHeaderCloseButton: () => HTMLElement | null;
  getCancellationButtonText: () => string;
  isCancellationButtonPrefixIconExists: () => boolean;
  isCancellationButtonSuffixIconExists: () => boolean;
  clickOnCancellationButton: () => void;
  clickOnHeaderCloseButton: () => void;
  isThemeExist: (theme: MessageBoxFunctionalLayoutTheme) => boolean;
  getFooter: () => HTMLElement | null;
  getTitle: () => string;
  getChildBySelector: (selector: string) => HTMLElement | null;
  isCancelEnable: () => boolean;
  isConfirmationEnable: () => boolean;
  toHaveBodyPadding: () => boolean;
}
